import { Navigate, useParams } from "react-router-dom";

import SignalFormPage from "@/components/Signals/SignalFormPage";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useGetSignal } from "@/queries/signals";

const EditSignalPage = () => {
  const { signalId } = useParams();
  const userToken = useAuth()?.userToken ?? "";
  const workspaceId = useUser()?.activeWorkspaceId ?? 0;
  const parsedSignalId = Number(signalId);
  const hasValidSignalId = Number.isFinite(parsedSignalId);

  const { data, isLoading, isError } = useGetSignal({
    userToken,
    workspaceId,
    signalId: parsedSignalId,
    enabled: hasValidSignalId,
  });

  if (!hasValidSignalId) {
    return <Navigate to={`/workspace/${workspaceId}/signals`} replace />;
  }

  if (isLoading) {
    return (
      <div className="px-8 pt-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="mt-6 h-[480px] w-full" />
      </div>
    );
  }

  if (isError || !data?.signal) {
    return <Navigate to={`/workspace/${workspaceId}/signals`} replace />;
  }

  return <SignalFormPage mode="edit" signal={data.signal} />;
};

export default EditSignalPage;
